<template>
  <div id="app">
    <router-view />

    <div class="app-actions" v-if="!isStandalone && showInstallButton">
      <button @click="installApp">Instaleaza aplicatia</button>
    </div>

    <div class="app-actions ios-install-hint" v-if="showIosInstallHint">
      <div class="ios-install-card">
        <div>Pentru instalare pe iPhone:</div>
        <div>Safari -&gt; Share -&gt; Add to Home Screen</div>
        <button @click="dismissIosInstallHint">Am inteles</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deferredPrompt: null,
      showInstallButton: false,
      showIosInstallHint: false,
      isStandalone: false,
    };
  },
  mounted() {
    const mq = window.matchMedia('(display-mode: standalone)');
    const isiOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent)
      || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);

    this.isStandalone = mq.matches || window.navigator.standalone === true;
    window.__fcfazInstallPromptVisible = false;

    if (mq.addEventListener) {
      mq.addEventListener('change', (e) => {
        this.isStandalone = e.matches;
        if (e.matches) {
          window.__fcfazInstallPromptVisible = false;
        }
      });
    }

    if (!this.isStandalone) {
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        this.deferredPrompt = e;
        this.showInstallButton = true;
        window.__fcfazInstallPromptVisible = true;
      });
    }

    window.addEventListener('appinstalled', () => {
      this.showInstallButton = false;
      this.showIosInstallHint = false;
      window.__fcfazInstallPromptVisible = false;
    });

    if (
      isiOS &&
      !this.isStandalone &&
      sessionStorage.getItem('fcfaz_ios_install_hint_dismissed') !== '1'
    ) {
      this.showIosInstallHint = true;
    }
  },
  methods: {
    async installApp() {
      if (!this.deferredPrompt) return;
      this.deferredPrompt.prompt();
      await this.deferredPrompt.userChoice;
      this.deferredPrompt = null;
      this.showInstallButton = false;
      window.__fcfazInstallPromptVisible = false;
    },
    dismissIosInstallHint() {
      this.showIosInstallHint = false;
      sessionStorage.setItem('fcfaz_ios_install_hint_dismissed', '1');
    },
  },
};
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
}

#app {
  box-sizing: border-box;
  display: flow-root;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100dvh;
}

@media all and (display-mode: standalone) {
  #app {
    padding-top: calc(env(safe-area-inset-top) + 20px);
    padding-right: env(safe-area-inset-right);
    padding-bottom: env(safe-area-inset-bottom);
    padding-left: env(safe-area-inset-left);
    padding-top: calc(constant(safe-area-inset-top) + 20px);
  }

  .navbar.fixed-top, .fixed-top,
  .navbar.fixed-bottom, .fixed-bottom {
    padding: 0 !important;
  }
}

.app-actions {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.app-actions button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin: 10px;
}

.app-actions button:hover {
  background-color: #0056b3;
}

.ios-install-card {
  max-width: 320px;
  padding: 14px 16px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
}

.ios-install-card div + div {
  margin-top: 4px;
}

.ios-install-hint button {
  margin-top: 10px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.loader{color:#fff;position:fixed;box-sizing:border-box;left:-9999px;top:-9999px;width:0;height:0;overflow:hidden;z-index:999999}.loader:after,.loader:before{box-sizing:border-box;display:none}.loader.is-active{background-color:rgba(0,0,0,.85);width:100%;height:100%;left:0;top:0}.loader.is-active:after,.loader.is-active:before{display:block}.loader-bar[data-text]:before{top:calc(50% - 40px);color:#fff}.loader-bar:after{content:"";position:fixed;top:50%;left:50%;width:200px;height:20px;transform:translate(-50%,-50%);background:linear-gradient(-45deg,#4183d7 25%,#52b3d9 0,#52b3d9 50%,#4183d7 0,#4183d7 75%,#52b3d9 0,#52b3d9);background-size:20px 20px;box-shadow:inset 0 10px 0 hsla(0,0%,100%,.2);animation:moveBar 1.5s linear infinite reverse}.loader-bar[data-rounded]:after{border-radius:15px}.loader-bar[data-inverse]:after{animation-direction:normal}@keyframes moveBar{0%{background-position:0 0}to{background-position:20px 20px}}
</style>
